import type {PageObject} from '@PosterWhiteboard/page/page.types';
import type {UserObject} from '@PosterWhiteboard/user/user.types';
import type {PosterTypeObject} from '@PosterWhiteboard/poster-type/poster-type.types';
import type {GridObject} from '@PosterWhiteboard/poster/grid.class';
import type {BleedObject} from '@PosterWhiteboard/poster/bleed.class';
import type {FoldObject} from '@PosterWhiteboard/poster/fold.class';
import type {FolderObject} from '@PosterWhiteboard/classes/folder.class';
import type {PosterScalingObject} from '@PosterWhiteboard/poster/poster-scaling.class';
import type {DrawingObject} from '@PosterWhiteboard/poster/poster-drawing/poster-drawing';
import type {PosterModeObject} from '@PosterWhiteboard/poster/poster-mode.class';
import type {ItemsMultiSelectObject} from '@PosterWhiteboard/poster/items-multi-select.class';
import type {TextItemObject} from '@PosterWhiteboard/items/text-item/text-item.types';

export const POSTER_VERSION = {
  CURRENT: 53,
  SHADOW_IMPROVEMENT: 15,
  FABRIC_3_UPDATE: 12,
  FABRIC_2_UPDATE: 11,
  HTML5: 10,
  LEGACY: 3,
};

export const PAGE_END_TIME_TOLERANCE_SECONDS = 0.05;

export interface PosterEvents {
  seeked: never;
  'textSlide:added': string;
  'fabricCanvas:touch:start': never;
  modified: never;
}

export interface PosterPageObject {
  pagesHashMap: Record<string, PageObject>;
  pageOrder: string[];
}

export interface PosterLoadObject {
  hashedID: string;
  type: PosterTypeObject;
  userWidth: number;
  userHeight: number;
  units: string;
  version: number;
  name: string;
  width: number;
  height: number;
  description: string;
  isTemplate: boolean;
  isPublic: boolean;
  isCopyable: boolean;
  isPurchaseable: boolean;
  createdOn: number;
  lastModified: number;
  idLastModifier: string;
  isInternal: boolean;
  seoName: string;
  id: string;
  creator?: UserObject;
  owner?: UserObject;
  pages: PosterPageObject;
}

export interface ResizeDimensions {
  left: number;
  top: number;
  scaleFactor: number;
}

export interface PosterObject extends PosterLoadObject {
  scaling: PosterScalingObject;
  duration: number;
  bleed: BleedObject;
  folder: FolderObject;
  grid: GridObject;
  mode: PosterModeObject;
  fold: FoldObject;
  drawing: DrawingObject;
  itemsMultiSelect: ItemsMultiSelectObject;
  activePageId: string;
  copyKey: string;
  isInitialized: boolean;
  uploadingImages: string[];
}

export const POSTER_GETTY_LIMIT = {
  IMAGES: 6,
  VIDEOS: 3,
  EXTRACTED_GETTY_STICKER: 20,
};

export const MAX_POSTER_NAME_LENGTH = 100;

export type AiTextMorphChanges = Partial<TextItemObject>;

export interface AiTextMorphResponse {
  textContentChanges: Record<string, AiTextMorphChanges>;
}
